/* import __COLOCATED_TEMPLATE__ from './scim-warning.hbs'; */
/* RESPONSIBLE TEAM: team-app-security */
import Component from '@glimmer/component';

interface Signature {
  Args: {
    permissionsObject: {
      assigned_via_scim: boolean;
    };
    hasChanges?: boolean;
  };
  Element: HTMLDivElement;
}

export default class ScimWarning extends Component<Signature> {
  get containerClasses() {
    return this.args.hasChanges
      ? 'bg-error-container border-error-border'
      : 'bg-notice-container border-notice-border';
  }

  get iconColor() {
    return this.args.hasChanges ? 'text-error' : 'notice-fill';
  }

  get textClasses() {
    return this.args.hasChanges ? 'text-error' : 'text-notice';
  }

  get messageKey() {
    return this.args.hasChanges
      ? 'settings.teammates.permissions.scim-managed-alert'
      : 'settings.teammates.permissions.scim-managed-warning';
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Settings::Teammates::Permissions::ScimWarning': typeof ScimWarning;
    'settings/teammates/permissions/scim-warning': typeof ScimWarning;
  }
}
